import { c as _c } from "react/compiler-runtime";
import { CustomError } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';
import { useGlobalStore } from '@/stores/GlobalStore';
const LOCATION_CONSENT_DECLINED_KEY = 'denied-location-drawer';

/**
 * 위치기반서비스 동의의 단일 진실 출처(single source of truth).
 *
 * - `isConsented`: 동의 상태. 비로그인은 동의 절차가 없어 항상 true.
 *                  `undefined`는 로딩 중을 의미.
 * - `ensureConsent`: 동의 필요 시 drawer를 띄우고 응답까지 대기 후 결과 반환.
 *                    이미 동의된 상태면 즉시 true,
 *                    이번 세션에 거부 이력이 있으면 즉시 false.
 */
export const useLocationConsent = () => {
  const $ = _c(9);
  const isLogin = useAuthStore(_temp);
  const setDrawer = useGlobalStore(_temp2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthQueryOptions["get:/wello/v2/auth/member-wello/location-service-consent"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !!isLogin;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: _temp3
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const consentQuery = useQuery(t2);
  const isConsented = isLogin === undefined ? undefined : isLogin === false ? true : consentQuery.data;
  let t3;
  if ($[3] !== isConsented || $[4] !== setDrawer) {
    t3 = async () => {
      if (isConsented === undefined) {
        throw new CustomError({
          return_message: "\uC704\uCE58 \uAE30\uBC18 \uC11C\uBE44\uC2A4 \uB3D9\uC758 \uC815\uBCF4\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
        });
      }
      if (isConsented === true) {
        return true;
      }
      if (sessionStorage.getItem(LOCATION_CONSENT_DECLINED_KEY) === "true") {
        return false;
      }
      return new Promise(resolve => {
        setDrawer(async isAgree => {
          if (!isAgree) {
            sessionStorage.setItem(LOCATION_CONSENT_DECLINED_KEY, "true");
          }
          resolve(isAgree);
        });
      });
    };
    $[3] = isConsented;
    $[4] = setDrawer;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const ensureConsent = t3;
  let t4;
  if ($[6] !== ensureConsent || $[7] !== isConsented) {
    t4 = {
      isConsented,
      ensureConsent
    };
    $[6] = ensureConsent;
    $[7] = isConsented;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(t0) {
  const {
    setHandleLocationServiceConsentDrawer
  } = t0;
  return setHandleLocationServiceConsentDrawer;
}
function _temp3(data) {
  return data.context?.locationServiceConsentYN ?? false;
}